import { required, length, email } from "../../../utils/validators";
// import Auth from "../../auth/auth";
import { useEffect, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import Input from "../../../components/form/input/input";

function ResetPassword(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [state, setState] = useState({
    loginForm: {
      email: {
        value: "",
        isValid: true,
        // touched: true,
        message: "please enter a valid email",
        validators: [required, email],
        required: true,
      },
    },
    formIsValid: false,
  });

  const navigate = useNavigate();
  const submitHandler = async (e) => {
    const email = state.loginForm.email;

    const signin = await props.onSignin(e, {
      email: email.value,
    });
    if (signin) {
      navigate("/user/profile?");
    }
  };
  const inputChangeHandler = (input, value) => {
    setState((prevState) => {
      let isValid = true;
      for (const validator of prevState.loginForm[input].validators) {
        isValid = isValid && validator(value);
      }
      const updatedForm = {
        ...prevState.loginForm,
        [input]: {
          ...prevState.loginForm[input],
          isValid: isValid,
          value: value,
        },
      };
      let formIsValid = true;
      for (const inputName in updatedForm) {
        formIsValid = formIsValid && updatedForm[inputName].valid;
      }
      return {
        loginForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  };

  return (
    <>
      <section className="flex flex-col items-center justify-center h-auto p-32 gap-5">
        <p className="w-96 text-left dark:bg-slate-800 bg-slate-200 p-5 rounded-md">
          To reset your password, enter your email below and submit.
          <br />
          An email will be sent to you with instructions about how to complete
          the process.
        </p>
        <form
          onSubmit={submitHandler}
          className="h-full  w-96  p-6 dark:bg-slate-700 bg-gray-400 rounded-md"
        >
          <Input
            id="email"
            label="Email"
            type="email"
            control="input"
            onChange={inputChangeHandler}
            value={state.loginForm["email"].value}
            valid={state.loginForm["email"].isValid}
            message={state.loginForm["email"].message}
            required={state.loginForm["email"].required}
          />

          <button
            className="btn float-right mt-6"
            type="submit"
            // loading={props.loading}
          >
            submit
          </button>
        </form>
      </section>
    </>
  );
}

export default ResetPassword;
